import { sprintf } from 'sprintf-js';

/**
 *
 * @param {String} string String format
 * @param {Array} params List of values to inject in string with sprintf
 * @returns {String}
 * @private
 */
function injectParams(string, params) {
    if (params.constructor === Array) return sprintf(string, ...params);

    throw new Error('`params` argument in translate function should be an array');
}

/**
 * @param {String} string to translate
 * @param {Array=} params List of values to inject in string to translate
 * @returns {String} string String to translate
 *
 * Usage :
 *  translate('string', [])
 *  translate('Hello %s', ['Jordi'])
 */
function translate(string, params = []) {
    return injectParams(string, params);
}

/**
 * @param {String} string String for singular translation
 * @param {String} pluralString String for plural translation
 * @param {Number} count Count to determine plural or not
 * @param {Array=} params List of values to inject in string to translate
 * @returns {String}
 *
 * Usage:
 *  translatePlural('One apple', 'Apples', 2) // Return 'Apples'
 *  translatePlural('%s apple', '%s apples', 3, [3]) // Return '3 apples'
 */
function translatePlural(string, pluralString, count, params) {
    if (count > 1) {
        return translate(pluralString, params);
    }
    return translate(string, params);
}

/**
 * Field translation.
 * @type {Object}
 */
const FIELDS = {
    address_name: 'Adresse',
    area: 'Surface',
    bathroom_count: 'Nb. de salles de bain',
    bedroom_count: 'Nb. de chambres',
    build_at: 'Date de construction',
    build_period: 'Période de construction',
    cellar: 'Cave',
    city_name: 'Ville',
    contract_final_fai_price: 'Prix FAI',
    contract_final_net_price: 'Prix net',
    elevator: 'Ascenseur',
    floor: 'Etage',
    floor_count: "Nb. total d'étages",
    ground_garden: 'Rez-de-jardin',
    item_subtype: 'Sous-type de bien',
    item_type: 'Type de bien',
    parking: 'Places de parking',
    parking_count: 'Nb. de parkings',
    ref_from_realtor: 'Référence du bien',
    room_count: 'Nb. de pièces',
    sale_agreement_at: 'Date de signature de la promesse',
    terrace: 'Terrasse',
    terrace_area: 'Surface terrasse',
    to_renovate: 'A rénover',
    virtual_tour: 'Visite virtuelle',
    zip: 'Code postal',
    level_count: 'Nombre de niveaux',
};

/**
 * Transalte field for given name.
 * @param  {String} fieldName Field name
 * @return {String}           Translated field value
 */
function translateField(fieldName) {
    if (fieldName in FIELDS) {
        return FIELDS[fieldName];
    }
    return '';
}

export { injectParams, translate, translatePlural, translateField };
